/** eslint-disable @typescript-eslint/no-explicit-any */
/** eslint-disable @typescript-eslint/no-explicit-any */
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../../redux/HooksRedux';
import { useEffect, useState } from 'react';
import * as applicationTypeOptionAction from '../../../redux/applicationTypeOption/applicationTypeAction';
import {
  capitalizeFirstLetter,
  checkAccess,
  convertToLabelValue,
  parseIntoNumber
} from 'utils/helpers';
import {
  errorNotification,
  successNotification
} from 'base/notifications/Notifications';
import { APPLICATION_TYPE_OPTION } from 'constant/RoutesUrls';
import {
  ApplicationRequest,
  ApplicationTypeProductI,
  OptionI,
  ProductFormInterface,
  ProductPageInterface,
  applicationTypeOptionI
} from '../../../../types/interface';
import * as productAction from '../../../redux/product/productAction';
import validationFunctions from 'utils/validationUtils';
import { applicationTypeOptionValidation } from 'utils/validations/ValidationsSet/ApplicationTypeOptionValicationSet';
import { t } from 'i18next';
import { ColumnDef } from '@tanstack/react-table';
import { UilTrashAlt } from '@iconscout/react-unicons';
import { Card, Dropdown, Form, Table } from 'react-bootstrap';
import ConditionalRender from 'base/ConditionalRender/ConditionalRender';
import { StandardLoader } from 'base/Loader/Loader';
import { StandardButton } from 'base/StandardButton/StandardButton';
import StandardInput from 'base/StandardInput/StandardInput';
import StandardSelect from 'base/StandardSelect/StandardSelect';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DraggableProductItem } from './DragableProductItem';
import DeleteModel from 'base/DeleteModal/DeleteModal';
import { ProductTableModal } from './ProductTableModal';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { modules } from 'utils/enums/misc';

export const ApplicationTypeOptionForm = () => {
  const { optionId } = useParams();
  const id = parseInt(optionId!);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isProductLoading, setIsProductLoading] = useState<boolean>(false);
  const [optionType, setOptionType] = useState('');
  const [optionTypeGerman, setOptionTypeGerman] = useState('');
  const [isRequestOptionArchive, setIsRequestOptionArchive] =
    useState<boolean>(false);
  const [description, setDescription] = useState('');
  const [productList, setProductList] = useState<Array<OptionI>>([]);
  const [productChangeValue, setProductChangeValue] = useState<number[]>();

  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [addProductOption, setAddProductOption] = useState<
    ProductPageInterface[]
  >([]);
  const [popupGetId, setPopupGetId] = useState<ApplicationTypeProductI[]>([]);

  const [buttonErrorText, setbuttonErrorText] = useState('');

  const [productDeleteId, setProductDeleteId] = useState<number>();
  const [showDeletePopup, setShowDeletePopup] = useState<boolean>(false);
  const [showError, setShowError] = useState<boolean>(false);
  const [deleteApplicationTypeOption, setDeleteApplicationTypeOption] =
    useState<{ id: number; showDeletePopup: boolean }>({
      id: 0,
      showDeletePopup: false
    });
  const userPermission = useSelector(
    (state: RootState) => state.userProfile.permission
  );

  const moveItem = (dragIndex: number, hoverIndex: number) => {
    const draggedItem = popupGetId[dragIndex];
    const updatedItems = [...popupGetId];
    updatedItems.splice(dragIndex, 1);
    updatedItems.splice(hoverIndex, 0, draggedItem);
    setPopupGetId(updatedItems);
  };

  const getAllApplicationTypeOption = async () => {
    setIsLoading(true);
    try {
      const response = await dispatch(
        applicationTypeOptionAction.getApplicationTypeOption()
      );

      if (response.status === 200) {
        const convertvalue = convertToLabelValue(
          response.data?.data,
          'name',
          'application_request_id'
        );
        setProductList(convertvalue);
      } else {
        errorNotification(response?.data?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getSingleApplicationTypeOption = async () => {
    if (
      !checkAccess([modules.APPLICATION_REQUEST_OPTION.edit], userPermission)
    ) {
      navigate(APPLICATION_TYPE_OPTION);
      return;
    }
    try {
      const response = await dispatch(
        applicationTypeOptionAction.getSingleApplicationTypeOption(id)
      );
      if (response.status === 200) {
        const requestArray: number[] = [];
        setOptionType(response.data.application_type_option.name);
        setOptionTypeGerman(
          response.data.application_type_option.name_german || ''
        );
        setDescription(response.data.application_type_option.description);
        response.data.application_type_option.application_requests.map(
          (item: ApplicationRequest) => {
            return requestArray.push(item.application_request_id);
          }
        );
        setProductChangeValue(requestArray);
        setPopupGetId(response.data.application_type_option.products);
        setIsRequestOptionArchive(
          response.data.application_type_option.is_archived
        );
        setIsLoading(false);
      } else {
        setIsLoading(false);
        navigate(APPLICATION_TYPE_OPTION);
        errorNotification(response?.data?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const deleteProductMapping = () => {
    const updatedArray = [...popupGetId];
    updatedArray.splice(productDeleteId as number, 1);
    setPopupGetId(updatedArray);
    setShowDeletePopup(false);
    setProductDeleteId(undefined);
  };
  const handleDirectDelete = (index: number) => {
    setProductDeleteId(index);
    setShowDeletePopup(true);
  };
  // get all product inside model.
  const getAllProduct = async () => {
    try {
      const response = await dispatch(
        productAction.getAllProduct({ limit: 999, page: 1, keyword: '' })
      );

      if (response.status === 200) {
        setAddProductOption(
          response.data?.data?.filter(
            (item: ProductFormInterface) => item?.is_archived === false
          )
        );
      } else {
        errorNotification(response?.data?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsProductLoading(false);
    }
  };

  const getDataInModel = (data: ApplicationTypeProductI[]) => {
    setPopupGetId(data);
  };

  const handleSubmit = async (e: React.FormEvent, isArchive?: boolean) => {
    e.preventDefault();
    const apiData: applicationTypeOptionI = {
      request_option_name: optionType,
      request_option_name_german: optionTypeGerman,
      request_option_description: description,
      request_ids: productChangeValue,
      product_ids: popupGetId?.map(item => {
        return item.product_id;
      }),
      is_archived:
        typeof isArchive === 'boolean' ? isArchive : isRequestOptionArchive
    };

    const validate: boolean = validationFunctions.checkFormValidity(
      {
        optionType,
        optionTypeGerman,
        productChangeValue,
        popupGetId
      },
      applicationTypeOptionValidation
    );

    if (!validate) {
      setShowError(true);
      if (!popupGetId || popupGetId.length === 0) {
        setbuttonErrorText(t('application_type_option_form.error_text'));
      } else {
        setbuttonErrorText('');
      }
      setIsLoading(false);
      return;
    } else {
      setShowError(false);
      setIsLoading(true);
      if (
        id &&
        checkAccess([modules.APPLICATION_REQUEST_OPTION.edit], userPermission)
      ) {
        try {
          const response = await dispatch(
            applicationTypeOptionAction.updateApplicationTypeOption(id, apiData)
          );
          if (response.status === 200) {
            successNotification(response.data?.message);
            navigate(APPLICATION_TYPE_OPTION);
          } else {
            errorNotification(response.data.message);
          }
        } catch (error) {
          console.log(error);
        } finally {
          setIsLoading(false);
        }
      } else if (
        checkAccess([modules.APPLICATION_REQUEST_OPTION.create], userPermission)
      ) {
        // create application type option.
        try {
          const response = await dispatch(
            applicationTypeOptionAction.createApplicationTypeOption(apiData)
          );
          if (response.status === 201) {
            successNotification(response.data?.message);
            navigate(APPLICATION_TYPE_OPTION);
          } else {
            errorNotification(response.data.message);
          }
        } catch (error) {
          console.log(error);
        } finally {
          setIsLoading(false);
        }
      } else {
        navigate(APPLICATION_TYPE_OPTION);
      }
    }
  };

  useEffect(() => {
    getAllApplicationTypeOption();
  }, []);

  useEffect(() => {
    if (id) {
      getSingleApplicationTypeOption();
    }
  }, [id]);

  useEffect(() => {
    if (popupGetId?.length > 0) {
      setbuttonErrorText('');
    } else if (popupGetId?.length == 0) {
      setbuttonErrorText(t('application_type_option_form.error_text'));
    }
  }, [popupGetId]);

  useEffect(() => {
    setIsLoading(true);
    getAllApplicationTypeOption();
  }, []);

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      getSingleApplicationTypeOption();
    }
  }, [id]);

  useEffect(() => {
    if (showPopup) {
      setIsProductLoading(true);
      getAllProduct();
    }
  }, [showPopup]);

  const column: ColumnDef<ApplicationTypeProductI>[] = [
    {
      accessorKey: t('applications.table.title_1'),
      cell: ({ row: { index } }) => index + 1
    },
    {
      accessorKey: t('general.common_text.text_12'),
      cell: ({ row: { original } }) => {
        return <div>{original.name}</div>;
      }
    },
    {
      accessorKey: t('general.common_text.text_8'),
      cell: ({ row: { index } }) => {
        return (
          <UilTrashAlt
            className="cursor-pointer text-danger"
            onClick={() => {
              setShowDeletePopup(true);
              setProductDeleteId(index);
            }}
          />
        );
      }
    }
  ];

  const renderTableModal = () => {
    if (showPopup) {
      return (
        <ProductTableModal
          showPopup={showPopup}
          setShowPopup={setShowPopup}
          successFunction={() => {}}
          id={popupGetId}
          showTable={true}
          optionTable={addProductOption}
          getData={getDataInModel}
          headText={t('application_type_option_form.general.text_1')}
          title={t('general.common_text.text_12')}
          loading={isProductLoading}
        />
      );
    }
  };

  const handleDeleteApplicationTypeOption = async () => {
    setIsLoading(true);
    try {
      const response = await dispatch(
        applicationTypeOptionAction.deleteApplicationTypeOption(id!)
      );

      if (response?.status === 200) {
        successNotification(response.data?.message);
        setDeleteApplicationTypeOption({ id: 0, showDeletePopup: false });
        navigate(APPLICATION_TYPE_OPTION);
        setIsLoading(false);
      } else {
        errorNotification(response?.data?.message);
        setDeleteApplicationTypeOption({ id: 0, showDeletePopup: false });
        setIsLoading(false);
      }
    } catch (error) {
      setDeleteApplicationTypeOption({ id: 0, showDeletePopup: false });
      setIsLoading(false);
      console.log(error);
    }
  };

  const renderDeleteApplicationTypeOptionPopup = () => {
    if (deleteApplicationTypeOption.showDeletePopup) {
      return (
        <DeleteModel
          onConfirm={handleDeleteApplicationTypeOption}
          onCancel={() =>
            setDeleteApplicationTypeOption({ id: 0, showDeletePopup: false })
          }
        />
      );
    }
  };

  const renderDeleteModal = () => {
    if (showDeletePopup) {
      return (
        <DeleteModel
          onConfirm={deleteProductMapping}
          onCancel={() => setShowDeletePopup(false)}
        />
      );
    }
  };

  return (
    <Card>
      <ConditionalRender condition={!isLoading} fallBack={<StandardLoader />}>
        <Form onSubmit={handleSubmit}>
          <Card.Header className="py-2">
            <div className="row justify-content-between align-items-center gap-3">
              <div className="w-auto">
                <h3 className='m-0'>{capitalizeFirstLetter(t('header.text.text_6'))} </h3>
              </div>
              <div className="d-flex gap-2 w-auto">
                <StandardButton
                  onClick={() => {
                    navigate(APPLICATION_TYPE_OPTION);
                  }}
                  buttonText={t('general.common_text.text_15')}
                  variant="outline-danger"
                />
                <StandardButton
                  onClick={handleSubmit}
                  type="submit"
                  buttonText={
                    id
                      ? t('general.common_text.text_18')
                      : t('general.common_text.text_2')
                  }
                />
                <ConditionalRender condition={!!id}>
                  <Dropdown
                    id="request_option_id"
                    placement="auto"
                    className="position-static"
                  >
                    <Dropdown.Toggle className="no-padding no-margin p-0 d-flex bg-transparent">
                      <StandardButton
                        buttonText={capitalizeFirstLetter(
                          t('general.common_text.text_8')
                        )}
                        onClick={() => {}}
                        variant="outline-danger"
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="p-0">
                      <ConditionalRender
                        condition={
                          checkAccess(
                            [modules.APPLICATION_REQUEST_OPTION.edit],
                            userPermission
                          ) && !!id
                        }
                      >
                        <Dropdown.Item
                          className="pe-0 border-bottom"
                          onClick={e => {
                            handleSubmit(e, !isRequestOptionArchive);
                          }}
                        >
                          <span className="d-flex fs-16 p-0 font-normal">
                            <p className="mb-0">
                              <ConditionalRender
                                condition={isRequestOptionArchive}
                                fallBack={t('common_table.text_5')}
                              >
                                {t('common_table.text_4')}
                              </ConditionalRender>
                            </p>
                          </span>
                        </Dropdown.Item>
                      </ConditionalRender>
                      <ConditionalRender
                        condition={checkAccess(
                          [modules.APPLICATION_REQUEST_OPTION.delete],
                          userPermission
                        )}
                      >
                        <Dropdown.Item
                          onClick={() => {
                            setDeleteApplicationTypeOption({
                              id: parseIntoNumber(id),
                              showDeletePopup: true
                            });
                          }}
                        >
                          <span className="d-flex fs-16 font-normal p-0">
                            <p className="mb-0">
                              {capitalizeFirstLetter(
                                t('general.common_text.text_14')
                              )}
                            </p>
                          </span>
                        </Dropdown.Item>
                      </ConditionalRender>
                    </Dropdown.Menu>
                  </Dropdown>
                </ConditionalRender>
              </div>
            </div>
          </Card.Header>
          <Card.Body className="row flex-column flex-md-row">
            <div className="col-12 col-md-4">
              <StandardInput
                value={optionType}
                onChange={(e: string | number) => setOptionType(e?.toString())}
                placeholder={t(
                  'application_type_option_form.placeholder.text_1'
                )}
                className=""
                showError={showError}
                validations={applicationTypeOptionValidation.optionType}
                label={t('application_type_option_form.placeholder.text_1')}
                type=""
              />
            </div>
            <div className="col-12 col-md-4">
              <StandardInput
                value={optionTypeGerman}
                onChange={(e: string | number) =>
                  setOptionTypeGerman(e?.toString())
                }
                placeholder={t(
                  'application_type_option_form.placeholder.text_2'
                )}
                className=""
                showError={showError}
                validations={applicationTypeOptionValidation.optionTypeGerman}
                label={t('application_type_option_form.placeholder.text_2')}
                type=""
              />
            </div>
            <div className="col-12 col-md-4">
              <StandardSelect
                value={productChangeValue}
                placeholder={t(
                  'application_type_option_form.placeholder.text_3'
                )}
                onChange={e => setProductChangeValue(e)}
                showError={showError}
                isMulti={true}
                validations={applicationTypeOptionValidation.productChangeValue}
                options={productList}
                id=""
                label={t('application_type_option_form.placeholder.text_3')}
                formClassName=""
              />
            </div>
            <div className="col-12 col-md-4">
              <StandardInput
                className=""
                value={description}
                onChange={(e: string | number) => {
                  setDescription(e?.toString()?.trimStart());
                }}
                placeholder={t('general.common_text.text_16')}
                label={t('general.common_text.text_16')}
                showError={false}
                as={'textarea'}
                validations={[]}
                type=""
              />
            </div>
          </Card.Body>
          <Card.Footer>
            <StandardButton
              buttonText={t('general.common_text.text_17')}
              onClick={() => {
                setShowPopup(true);
              }}
              className="add-btn-style mt-1"
            />
            <ConditionalRender
              condition={(!popupGetId || popupGetId.length === 0) && showError}
            >
              <div className="row">
                <div className="col-lg-3">
                  <p className="text-danger error">
                    {capitalizeFirstLetter(buttonErrorText)}
                  </p>
                </div>
              </div>
            </ConditionalRender>
          </Card.Footer>
          <ConditionalRender condition={popupGetId?.length > 0}>
            <DndProvider backend={HTML5Backend}>
              <div className="product-list-container p-5 pt-1">
                <Table
                  className={'standard-table table-width phoenix-table'}
                  responsive
                  borderless={true}
                >
                  <thead className="mb-5">
                    <tr>
                      {column.map((column: any, index) => (
                        <th key={index} className="ps-0">
                          <div className="d-flex justify-content-between">
                            <div>
                              {capitalizeFirstLetter(column.accessorKey)}
                            </div>
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="ps-4 ">
                    {popupGetId.map((item, index) => (
                      <DraggableProductItem
                        key={item.product_id || index}
                        id={item.product_id || index}
                        index={index}
                        moveItem={moveItem}
                        item={item}
                        onDelete={handleDirectDelete}
                      />
                    ))}
                  </tbody>
                </Table>
              </div>
            </DndProvider>
          </ConditionalRender>
        </Form>
        {renderDeleteModal()}
        {renderTableModal()}
        {renderDeleteApplicationTypeOptionPopup()}
      </ConditionalRender>
    </Card>
  );
};
